import React, {  useEffect } from "react";
import { txtA } from "../../../Label/Lbl";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import ButtonBase from "@material-ui/core/ButtonBase";
import {  useInvCa, useInvMain } from "../../../St/Reviews/UseStyle";
import { useStylesNoTaxCashair } from "./BodyCashier1";

function HeaderCash(props) {
  const clasm = useInvMain();
  const clas = useInvCa();
  const {info, onUnmountComplete } = props;
  const classes = useStylesNoTaxCashair();
  useEffect(() => {
    setTimeout(async () => {
      onUnmountComplete();
    }, 0);
  }, []);


  return (
    <Grid item container>
      <Grid item xs={12} className={clasm.mincntr}>
        <Typography>
          <ButtonBase>
            {" "}
            <img
              src={`data:image/jpeg;base64,${info.Logo}`}
              className={clas.Hedlogo}
              alt={info.nameA}
            />{" "}
          </ButtonBase>
        </Typography>
      </Grid>

      <Grid item xs={12} className={[clasm.mincntr]}>
        <Typography className={classes.allWidth}>
          <b>{info.nameA}</b>
        </Typography>
      </Grid>
      <Grid item xs={5} className={[clasm.minrit]}>
        <Typography className={clas.contnt}>{info.Mobile}</Typography>
      </Grid>
      
      <Grid item xs={7} className={[clasm.mincntr]}>
        <Typography className={clas.contntSub}>{info.Address}</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography className={classes.allWidth} >
          <b>{info.tax_no}</b>
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography  style={{textAlign:"right", paddingRight:"0.5rem", fontSize: "0.7rem",fontWeight:"bold",paddingTop:"0.2rem"}}>
          <div style={{fontWeight:"bold", fontSize:"0.8rem"}}> {txtA.taxNumr + "" } </div>
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography className={classes.allWidth}>
          <b> {info.bsn_no}</b>
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography style={{textAlign:"right", paddingRight:"0.5rem", fontSize: "0.8rem",fontWeight:"bold",paddingTop:"0.2rem"}}>
          <div style={{fontWeight:"bold", fontSize:"0.8rem"}}> {"السجل التجاري "}</div>
        </Typography>
      </Grid>
      <br></br>


    </Grid>
  );
}
export default HeaderCash;
